import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { tableAnatomy as parts } from '@chakra-ui/anatomy';
import { mode } from '@chakra-ui/theme-tools';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle({
  th: {
    color: 'gray.400',
  },
  tr: {
    'td:first-of-type': {
      paddingStart: 0,
    },
    'th:first-of-type': {
      paddingStart: 0,
    },
  },
  td: {
    fontSize: 'sm',
  },
});

const variantSimple = definePartsStyle((props) => ({
  th: {
    color: mode('gray.400', 'gray.400')(props),
  },
}));

const tableTheme = defineMultiStyleConfig({
  baseStyle,
  variants: { simple: variantSimple },
});

export default tableTheme;
